export default "__VITE_ASSET__rR4n0YqZ__"